import { IconSvg } from '@/components/common/icons/IconSvg';
import { getColor } from '@/helpers/utils';

export const UserIcon = ({ size = 16 }) => <IconSvg size={size} icon="IcoRUserHeadset" color={getColor('support')} />;
